const style = {
    floatButtonNext: {
        background: '#122230',
        color: '#f5f5f5',
        position: 'absolute',
        right: '5vw',
        bottom: '10px',
    },
    floatButtonPrev: {
        background: '#122230',
        color: '#f5f5f5',
        position: 'absolute',
        left: '5vw',
        bottom: '10px',
    },
}

export default style
